import { render } from "./mat-slider.vue?vue&type=template&id=be5d116a&lang=true"
import script from "./mat-slider.vue?vue&type=script&lang=js"
export * from "./mat-slider.vue?vue&type=script&lang=js"

import "./mat-slider.vue?vue&type=style&index=0&id=be5d116a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__